import React, { useEffect } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { Benefits } from './components/Benefits';
import { FlavorShowcase } from './components/FlavorShowcase';
import { ProductReveal } from './components/ProductReveal';
import { PricingSection } from './components/PricingSection';
import { BonusSection } from './components/BonusSection';
import { StudentReviews } from './components/StudentReviews';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initUtmifyPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initUtmifyPixel();
  }, []);
  return <div className="min-h-screen font-body text-brown-dark bg-cream selection:bg-caramel selection:text-white" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <Benefits data-id="element-5" />
        <FlavorShowcase data-id="element-6" />
        <ProductReveal data-id="element-7" />
        <BonusSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <StudentReviews data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}